import { createBrandPreview } from "@appcaire/brand/browser";

/** Development-only palette comparison; production follows the published brand. */
export const brandPreview = createBrandPreview({
  enabled: import.meta.env.DEV,
});
